export enum NextRuntime {
  NodeJs = 'nodejs',
  Edge = 'edge',
}
